import ClosingCautionModal from '@/common/containers/Modals/ClosingCautionModal/ClosingCautionModal';

export default ClosingCautionModal;
